export const environment = {
	baseUrl: window["env"]["baseUrl"],
	requestListRefreshTime: window["env"]["requestListRefreshTime"],
	idleTimeMinutes: window["env"]["idleTimeMinutes"],
	performerUserAutoSetTime: window["env"]["performerUserAutoSetTime"],
	enableOtpAuthentication: window["env"]["enableOtpAuthentication"],

	apiUrl: window["env"]["baseUrl"] + window["env"]["apiUrl"],
	engubatorAddress: window["env"]["engubatorAddress"] + window["env"]["apiUrl"],
	dogAddress: (window["env"]["baseUrl"] + window["env"]["dogAddress"]),
	tmsgateAddress: (window["env"]["baseUrl"] + window["env"]["tmsgateAddress"]),
	finesAddress: (window["env"]["baseUrl"] + window["env"]["finesAddress"]),
	reportsApiUrl: (window["env"]["baseUrl"] + window["env"]["reportsApiUrl"]),
	instructionsAddress: (window["env"]["baseUrl"] + window["env"]["instructionsAddress"]),
};
